import BaseButtonWrapper from './BaseButtonWrapper';

export default BaseButtonWrapper;
